import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import styles from "./Content.css";

export default function Content({ children, className, ariaLabel }) {
  return (
    <main id="main" role="main" aria-label={ariaLabel} tabIndex="-1" className={classNames(styles.root, className)}>
      {children}
    </main>
  );
}

Content.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
};
